import { connect } from 'react-redux';
import { updateSharedResourceWatchStatus } from 'legacy/src/actions/sharedResources';
import setAPDCarouselData, {
  updateSingleVideoAPDCarouselData,
} from 'legacy/src/actions/apdCarousel';

const mapStateToProps = (state) => {
  const {
    classes: { items },
    userData,
    subject: { data: subjectData },
    featureFlag: {
      show_related_videos_carousel: showRelatedVideosCarousel,
      show_0pct_watched: showZeroWatchedFlag,
      ap_teacher_impersonates_student: apTeacherImpersonatesStudent,
    },
    courseOutline,
    apdCarouselData,
    impersonating,
  } = state;
  const isReadOnly = impersonating && impersonating.isReadOnly;
  const { chosenEducationPeriodCode } = userData;
  const teacherClasses = (items || []).filter(
    (section) =>
      section.educationPeriod ===
      Number.parseInt(chosenEducationPeriodCode, 10),
  );
  const { id: masterSubjectId } = subjectData;
  const subjectCourseOutline = courseOutline[masterSubjectId] || {};

  return {
    masterSubjectId,
    teacherClasses,
    userData,
    subjectCourseOutlineUnits: subjectCourseOutline.units || [],
    isLoadingSubjectCourseOutline: courseOutline.isLoadingSubjectCourseOutline,
    showRelatedVideosCarousel,
    apdCarouselData,
    showZeroWatchedFlag,
    isImpersonating:
      Boolean(isReadOnly && apTeacherImpersonatesStudent) ||
      window.localStorage.getItem('isReadOnly') === 'true',
  };
};

const withRedux = connect(mapStateToProps, {
  setSharedResourceWatchStatus: updateSharedResourceWatchStatus,
  setAPDCarouselData,
  updateSingleVideoAPDCarouselData,
});

export default withRedux;
